import { useEffect, useState } from "react";
import {
  About,
  Education,
  Experience,
  Languages,
  Links,
  Projects,
  Skills,
} from "./components/Sections";
import Sidebar from "./components/Sidebar";

const App = () => {
  // Initialize state from URL hash, default to 'about'
  const [activeTab, setActiveTab] = useState("about");
  const [isOpen, setIsOpen] = useState(false);

  // Sync state with URL Hash
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "");
      const validTabs = [
        "about",
        "experience",
        "projects",
        "education",
        "skills",
        "language",
        "contact",
      ];
      if (validTabs.includes(hash)) {
        setActiveTab(hash);
      }
    };

    // Run on mount and on every hash change
    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  // Update URL when tab is clicked
  const handleTabChange = (id) => {
    window.location.hash = id; // This triggers the hashchange event
    setIsOpen(false);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "about":
        return <About />;
      case "experience":
        return <Experience />;
      case "projects":
        return <Projects />;
      case "education":
        return <Education />;
      case "skills":
        return <Skills />;
      case "language":
        return <Languages />;
      case "contact":
        return <Links />;
      default:
        return <About />;
    }
  };

  return (
    <div className="bg-black min-h-screen text-neutral-300 lg:flex overflow-hidden selection:bg-emerald-500 selection:text-black">
      <Sidebar
        activeTab={activeTab}
        onTabChange={handleTabChange}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />

      <main className="flex-1 h-screen overflow-y-auto px-6 py-12 md:px-16 lg:px-24 scroll-smooth">
        <div className="max-w-4xl mx-auto pt-16 lg:pt-0">{renderContent()}</div>
      </main>
    </div>
  );
};

export default App;
